export default "__VITE_ASSET__C$8kvc5C__"